module.exports = __webpack_public_path__ + "img/shipbobIcon.5d09974d.svg";